import type { ProductDetailPageTranslation } from "@swo/storefront";
import type React from "react";
import { useT2 } from "../../domain/translations/translations";
import { PdpTranslationsContext } from "./PdpTranslationsContext";
import { useSmoothScrolling } from "../../hooks";

export const PDPSharedLayoutComponent: React.FC<{
  pdpTranslations: ProductDetailPageTranslation;
  children: React.ReactNode;
}> = ({ pdpTranslations, children }) => {
  const t = useT2(pdpTranslations);
  useSmoothScrolling(true);

  return <PdpTranslationsContext value={t}>{children}</PdpTranslationsContext>;
};
